module.exports = __webpack_public_path__ + "img/電気回路_6_1_1.8d19fd15.png";